import type { IconComponent } from '@components/icons/types'

/**
 * Renders an x icon.
 */
export const Close: IconComponent = ({ width, height, ...restOfProps }) => (
    <svg
        width={width}
        height={height}
        viewBox='0 0 20 20'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        {...restOfProps}
    >
        <path d='M2 2L18 18M18 2L2 18' stroke='currentColor' strokeWidth='3' />
    </svg>
)
